export type GroupTickets = 'none' | 'price_type' | 'price_zone';
export const GroupTickets = {
  None: 'none' as GroupTickets,
  PriceType: 'price_type' as GroupTickets,
  PriceZone: 'price_zone' as GroupTickets,
  Row: 'row' as GroupTickets
};
